export default __webpack_public_path__ + "static/media/checkbox-checked.12cbd29a.svg";